import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'
import LoginForm from '../../components/auth/LoginForm'
import { GrSecure } from 'react-icons/gr'

function LoginPage(props) {
    const url = window.location.href
    return (
        <div>
            <Helmet>
                <title>Login - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta
                    property="description"
                    content="" />
            </Helmet>
            <main className="flex-1 flex flex-col items-center justify-center p-4 sm:p-8">
                <div className="w-full max-w-[1000px] bg-white dark:bg-[#1a2c35] rounded-xl shadow-card overflow-hidden grid md:grid-cols-2 min-h-[600px] border border-border-color dark:border-gray-800">
                    
                    <div className="p-8 md:p-12 flex flex-col justify-center order-2 md:order-1 relative">
                        <div className="mb-8">
                            <h1 className="text-3xl font-bold tracking-tight text-text-main dark:text-white mb-2">Welcome back</h1>
                            <p className="text-text-secondary dark:text-gray-400 text-base">Please enter your details to access the admin dashboard.</p>
                        </div>
                        <LoginForm/>
                    </div>
                    
                    <div className="hidden md:flex flex-col relative order-1 md:order-2 bg-slate-50 dark:bg-slate-900 overflow-hidden">
                        <div className="absolute inset-0 z-0">
                            <div className="w-full h-full bg-cover bg-center login-bg" data-alt="Abstract blue and white medical geometric pattern">
                            </div>
                            <div className="absolute inset-0 bg-primary/60 mix-blend-multiply"></div>
                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                        </div>
                        <div className="relative z-10 flex flex-col justify-end h-full p-12 text-white">
                            <div className="size-12 bg-white/20 backdrop-blur-md rounded-xl flex items-center justify-center mb-6 border border-white/30">
                                <span className="material-symbols-outlined text-3xl"><GrSecure/></span>
                            </div>
                            <h3 className="text-3xl font-bold mb-3 tracking-tight">Secure Admin Portal</h3>
                            <p className="text-white/90 text-lg leading-relaxed max-w-sm">
                                Manage nurse assignments, patient records, and platform settings securely from one place.
                            </p>
                        </div>
                    </div>
                </div>
            </main>

        </div>
    )
}

export default LoginPage